import React, { useState, useEffect } from "react";
import FormulaireVisa from "./FormulaireVisa";
import Admin from "./admin";
import "./tw.css";
import logo from "./logo.png";

// Liste des pays
const COUNTRY_OPTIONS = [
  { code: "AND", label: "Andorre (AND)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "AUT", label: "Autriche (AUT)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "BEL", label: "Belgique (BEL)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "BGR", label: "Bulgarie (BGR)", esta: false, etaCanada: true, etaAustralia: true },
  { code: "HRV", label: "Croatie (HRV)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "CYP", label: "Chypre (CYP)", esta: false, etaCanada: true, etaAustralia: true },
  { code: "CZE", label: "Tchequie (CZE)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "DNK", label: "Danemark (DNK)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "EST", label: "Estonie (EST)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "FIN", label: "Finlande (FIN)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "FRA", label: "France (FRA)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "DEU", label: "Allemagne (DEU)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "GRC", label: "Grece (GRC)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "HUN", label: "Hongrie (HUN)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "ISL", label: "Islande (ISL)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "IRL", label: "Irlande (IRL)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "ITA", label: "Italie (ITA)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "LVA", label: "Lettonie (LVA)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "LIE", label: "Liechtenstein (LIE)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "LTU", label: "Lituanie (LTU)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "LUX", label: "Luxembourg (LUX)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "MLT", label: "Malte (MLT)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "MCO", label: "Monaco (MCO)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "NLD", label: "Pays-Bas (NLD)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "NOR", label: "Norvege (NOR)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "POL", label: "Pologne (POL)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "PRT", label: "Portugal (PRT)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "ROU", label: "Roumanie (ROU)", esta: false, etaCanada: true, etaAustralia: true },
  { code: "SMR", label: "Saint-Marin (SMR)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "SVK", label: "Slovaquie (SVK)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "SVN", label: "Slovenie (SVN)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "ESP", label: "Espagne (ESP)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "SWE", label: "Suede (SWE)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "CHE", label: "Suisse (CHE)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "GBR", label: "Royaume-Uni (GBR)", esta: true, etaCanada: true, etaAustralia: true },

  { code: "AUS", label: "Australie (AUS)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "NZL", label: "Nouvelle-Zelande (NZL)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "JPN", label: "Japon (JPN)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "KOR", label: "Coree du Sud (KOR)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "SGP", label: "Singapour (SGP)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "TWN", label: "Taiwan (TWN)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "HKG", label: "Hong Kong (HKG)", esta: false, etaCanada: true, etaAustralia: true },
  { code: "MYS", label: "Malaisie (MYS)", esta: false, etaCanada: true, etaAustralia: true },

  { code: "CAN", label: "Canada (CAN)", esta: true, etaCanada: false, etaAustralia: true },
  { code: "USA", label: "Etats-Unis (USA)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "CHL", label: "Chili (CHL)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "MEX", label: "Mexique (MEX)", esta: false, etaCanada: true, etaAustralia: false },

  { code: "ISR", label: "Israel (ISR)", esta: true, etaCanada: true, etaAustralia: true },
  { code: "ARE", label: "Emirats Arabes Unis (ARE)", esta: false, etaCanada: true, etaAustralia: true },

  { code: "MAR", label: "Maroc (MAR)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "DZA", label: "Algerie (DZA)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "TUN", label: "Tunisie (TUN)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "SEN", label: "Senegal (SEN)", esta: false, etaCanada: false, etaAustralia: false },

  { code: "BRA", label: "Bresil (BRA)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "CHN", label: "Chine (CHN)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "IND", label: "Inde (IND)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "RUS", label: "Russie (RUS)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "PAK", label: "Pakistan (PAK)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "PHL", label: "Philippines (PHL)", esta: false, etaCanada: false, etaAustralia: false },
  { code: "VNM", label: "Vietnam (VNM)", esta: false, etaCanada: false, etaAustralia: false },

  { code: "OTHER", label: "Autre nationalite", esta: false, etaCanada: false, etaAustralia: false },
];

const STORAGE_KEY = "visagovassist_demandes";

function getProgramLabel(destination) {
  if (destination === "usa") return "l'ESTA (États-Unis)";
  if (destination === "canada") return "l'eTA canadienne";
  if (destination === "australie") return "l'ETA australienne";
  return "l'autorisation électronique";
}

function getEligibility(formData) {
  if (!formData.country || !formData.destination) return null;
  const country = COUNTRY_OPTIONS.find((c) => c.code === formData.country);
  if (!country) return null;

  let eligible = false;
  if (formData.destination === "usa") eligible = country.esta;
  if (formData.destination === "canada") eligible = country.etaCanada;
  if (formData.destination === "australie") eligible = country.etaAustralia;

  return {
    eligible,
    programLabel: getProgramLabel(formData.destination),
    countryLabel: country.label,
  };
}
function VisaSummary({ country, destination }) {
  if (!country || !destination) return null;
  const content = {
    usa: {
      stay: "90 jours par entrée",
      type: "ESTA (Electronic System for Travel Authorization)",
      info:
        "L’ESTA permet aux ressortissants de pays éligibles de se rendre aux États-Unis pour des séjours touristiques, professionnels ou de transit d’une durée maximale de 90 jours. La demande s’effectue entièrement en ligne. Une fois approuvée, l’autorisation ESTA est généralement valable pendant deux ans et permet plusieurs entrées.",
    },
    canada: {
      stay: "Jusqu’à 6 mois par entrée",
      type: "eTA (Autorisation de voyage électronique)",
      info:
        "L’eTA est requise pour les voyageurs exemptés de visa se rendant au Canada par voie aérienne. La demande est réalisée en ligne avant le départ.",
    },
    australie: {
      stay: "Jusqu’à 3 mois par entrée",
      type: "Autorisation électronique de voyage (ETA / eVisitor)",
      info:
        "L’autorisation électronique de voyage permet aux ressortissants de pays éligibles d’entrer en Australie pour des séjours touristiques ou professionnels de courte durée. La demande s’effectue en ligne avant le départ.",
    },
  };

  const d = content[destination];
  if (!d) return null;

  return (
    <div className="bg-white border border-slate-200 rounded-md shadow-sm p-6 mb-6 max-w-3xl mx-auto">
      <h2 className="text-sm font-semibold text-slate-900 mb-4">
        Informations relatives à votre demande
      </h2>

      <div className="space-y-2 text-sm text-slate-700">
        <p><strong>Nationalité :</strong> {country}</p>
        <p><strong>Durée maximale du séjour :</strong> {d.stay}</p>
        <p><strong>Type d’autorisation recommandé :</strong> {d.type}</p>
      </div>

      <p className="mt-4 text-xs text-slate-600 leading-relaxed">
        {d.info}
      </p>
    </div>
  );
}
function SummaryStep({ leadData, onContinue, onBack }) {
  return (
    <main className="min-h-screen bg-slate-50">
      <section className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-extrabold text-slate-900 mb-6">
          Vérification de votre demande
        </h1>

        <VisaSummary
          country={leadData.country}
          destination={leadData.destination}
        />

        <div className="bg-white border border-slate-200 rounded-lg p-5 space-y-4">
          <p className="text-sm text-slate-700">
            Veuillez vérifier les informations ci-dessus.
            Vous allez maintenant accéder au formulaire officiel
            nécessaire au traitement de votre demande.
          </p>

          <div className="flex gap-3">
            <button
              onClick={onBack}
              className="px-4 py-2 rounded-md border border-slate-300 text-sm"
            >
              Modifier
            </button>

            <button
              onClick={onContinue}
              className="ml-auto px-5 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold"
            >
              Continuer la demande
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}


// ---------- HOME (landing) ----------
function Home({ onStart, onOpenAdmin }) {
  const year = new Date().getFullYear();

  const [formData, setFormData] = useState({
    country: "",
    multiPassport: false,
    reason: "",
    destination: "",
  });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDestinationClick = (destination) =>
    setFormData((prev) => ({ ...prev, destination }));

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.country) {
      alert("Merci de sélectionner votre nationalité.");
      return;
    }

    if (!formData.destination) {
      alert("Merci de choisir une destination (USA, Canada ou Australie).");
      return;
    }

    onStart({
      country: formData.country,
      destination: formData.destination,
      multiPassport: formData.multiPassport,
    });
  };

  const eligibility = getEligibility(formData);

  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      {/* HEADER */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 md:w-10 md:h-10 bg-slate-900 rounded-lg flex items-center justify-center text-white font-bold text-[11px] md:text-xs shadow-sm">
            VSA
            </div>
            <div className="flex flex-col">
              <span className="font-semibold text-base md:text-lg text-slate-900 tracking-tight">
                VisaGovAssist
              </span>
              <span className="text-[10px] text-slate-500 hidden sm:inline">
                Assistance en ligne — ESTA / eTA / ETA
              </span>
            </div>
          </div>

          {/* NAV DESKTOP */}
          <nav className="hidden md:flex gap-5 text-sm text-slate-700 items-center">
            <a href="#services" className="hover:text-slate-900 transition-colors">
              Procédure
            </a>
            <a href="#benefices" className="hover:text-slate-900 transition-colors">
              Services
            </a>
            <a href="#faq" className="hover:text-slate-900 transition-colors">
              FAQ
            </a>
          </nav>

          {/* BOUTON MENU MOBILE */}
          <button
            type="button"
            className="md:hidden inline-flex items-center gap-2 px-2.5 py-1.5 rounded-lg border border-slate-300 text-[11px] text-slate-800 bg-white shadow-sm active:scale-[0.98] transition"
            onClick={() => setMobileMenuOpen((open) => !open)}
            aria-label="Ouvrir le menu"
            aria-expanded={mobileMenuOpen}
          >
            <span className="flex flex-col justify-center gap-[3px]">
              <span
                className={`block h-[2px] w-4 rounded-full bg-slate-800 transition-transform ${
                  mobileMenuOpen ? "translate-y-[3px] rotate-45" : ""
                }`}
              />
              <span
                className={`block h-[2px] w-4 rounded-full bg-slate-800 transition-opacity ${
                  mobileMenuOpen ? "opacity-0" : "opacity-80"
                }`}
              />
              <span
                className={`block h-[2px] w-4 rounded-full bg-slate-800 transition-transform ${
                  mobileMenuOpen ? "-translate-y-[3px] -rotate-45" : ""
                }`}
              />
            </span>
          </button>
        </div>

        {/* MENU DÉROULANT MOBILE */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-slate-200 bg-white">
            <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col gap-1.5 text-[13px] text-slate-800">
              <a
                href="#services"
                className="py-1.5 flex items-center justify-between hover:text-slate-900"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span>Procédure</span>
                <span className="text-slate-500">+</span>
              </a>
              <a
                href="#benefices"
                className="py-1.5 flex items-center justify-between hover:text-slate-900"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span>Services</span>
                <span className="text-slate-500">+</span>
              </a>
              <a
                href="#faq"
                className="py-1.5 flex items-center justify-between hover:text-slate-900"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span>FAQ</span>
                <span className="text-slate-500">+</span>
              </a>
            </div>
          </div>
        )}

        {/* TRUST BAR (texte simple, sans emojis) */}
        <div className="border-t border-slate-200 bg-slate-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 flex flex-wrap gap-3 items-center justify-center text-[12px] sm:text-xs text-slate-700 text-center leading-snug">
            <span className="whitespace-nowrap">Délai de traitement : 24 h</span>
            <span className="hidden sm:inline text-slate-300">•</span>
            <span className="whitespace-nowrap">Paiement sécurisé</span>
            <span className="hidden sm:inline text-slate-300">•</span>
            <span className="whitespace-nowrap">Réception par email</span>
            <span className="hidden sm:inline text-slate-300">•</span>
            <span className="whitespace-nowrap">Formulaire rapide</span>
          </div>
        </div>
      </header>
      {/* HERO + FORM */}
      <section id="debut" className="bg-slate-900 text-white">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-6 md:py-12 flex flex-col md:flex-row-reverse items-center justify-between gap-6 md:gap-10">
          {/* COL TEXTE + FORM */}
          <div className="w-full md:w-1/2 space-y-3 md:space-y-4">
            <div className="hidden md:inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-3 py-1 text-[10px] md:text-xs">
              <span className="text-slate-100">Assistance en ligne</span>
              <span className="text-slate-200/80">
                ESTA USA, eTA Canada, ETA Australie
              </span>
            </div>

            {/* TITRE MOBILE */}
            <h1 className="md:hidden text-2xl font-extrabold leading-snug text-center">
              Autorisation de voyage : dépôt et suivi
              <span className="block text-base font-medium text-slate-200 mt-1">
                États-Unis · Canada · Australie
              </span>
            </h1>

            {/* TITRE DESKTOP */}
            <h1 className="hidden md:block text-3xl font-extrabold leading-tight text-left">
              Déposer votre autorisation de voyage en ligne
              <span className="block text-slate-200 mt-2">
                ESTA USA · eTA Canada · ETA Australie
              </span>
            </h1>

            <p className="hidden sm:block text-slate-200/90 text-sm md:text-base leading-relaxed max-w-lg">
              Formulaire guidé en français, vérification du dossier et transmission
              des informations nécessaires à la soumission sur les plateformes officielles.
            </p>

            {/* FORM CARD */}
            <form
              onSubmit={handleSubmit}
              className="mt-1 bg-white text-slate-900 rounded-xl shadow-xl p-4 md:p-6 space-y-4 border border-slate-200"
            >
              <div className="flex items-center justify-between text-[11px] text-slate-500 mb-1">
                <span>Durée estimée : quelques minutes</span>
              </div>

              <div>
                <label className="block text-xs font-semibold text-slate-800">
                  Nationalité du passeport <span className="text-red-600">*</span>
                </label>
                <select
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                  className="mt-1 w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-800/30"
                >
                  <option value="">Sélectionnez votre nationalité</option>
                  {COUNTRY_OPTIONS.map((opt) => (
                    <option key={opt.code} value={opt.code}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-800 mb-1">
                  Destination <span className="text-red-600">*</span>
                </p>
                <div className="grid grid-cols-3 gap-2 text-xs">
                  {[
                    { key: "usa", label: "États-Unis", sub: "ESTA" },
                    { key: "canada", label: "Canada", sub: "eTA" },
                    { key: "australie", label: "Australie", sub: "ETA" },
                  ].map((dest) => {
                    const isActive = formData.destination === dest.key;
                    return (
                      <button
                        type="button"
                        key={dest.key}
                        onClick={() => handleDestinationClick(dest.key)}
                        className={`flex flex-col items-center border rounded-md py-2 px-1 transition ${
                          isActive
                            ? "border-slate-900 bg-slate-50 text-slate-900 shadow-sm"
                            : "border-slate-300 bg-white hover:border-slate-400"
                        }`}
                      >
                        <span className="font-semibold text-[11px]">
                          {dest.label}
                        </span>
                        <span className="text-[10px] text-slate-500">{dest.sub}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              {eligibility && (
                <p
                  className={`text-[11px] leading-snug ${
                    eligibility.eligible ? "text-emerald-700" : "text-red-600"
                  }`}
                >
                  {eligibility.eligible ? (
                    <>
                      <span className="font-semibold">{eligibility.countryLabel}</span>{" "}
                      est généralement éligible à{" "}
                      <span className="font-semibold">{eligibility.programLabel}</span>.
                      Vous pouvez poursuivre votre demande.
                    </>
                  ) : (
                    <>
                      <span className="font-semibold">{eligibility.countryLabel}</span>{" "}
                      n&apos;est pas éligible à {eligibility.programLabel}. Un visa
                      classique peut être requis auprès de l&apos;ambassade.
                    </>
                  )}
                </p>
              )}

              <button
                type="submit"
                className="w-full bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold py-2.5 rounded-md transition disabled:opacity-60"
              >
                Commencer la demande
              </button>

              <p className="text-[10px] text-slate-500 text-center">
                Aucune création de compte. Le paiement intervient lors de la validation finale du dossier.
              </p>

              {/* Social proof soft (sans emojis) */}
              <div className="pt-2 flex flex-col items-center gap-1 text-[10px] text-slate-600">
                <div>Accompagnement pour les voyageurs francophones.</div>
                <div>Demandes fréquentes : USA / Canada / Australie.</div>
              </div>
            </form>

            <ul className="hidden md:block pt-2 text-xs text-slate-200/90 space-y-1.5">
              <li>• Formulaire simplifié en français, pensé pour limiter les erreurs.</li>
              <li>• Dossier relu avant transmission des éléments nécessaires à la soumission.</li>
              <li>• Suivi par e-mail tout au long du traitement.</li>
              <li>• Paiement sécurisé — aucune donnée bancaire stockée.</li>
            </ul>
          </div>

          {/* COL VISUEL (plus sobre) */}
          <div className="hidden md:block md:w-1/2 mt-2 md:mt-0">
            <div className="relative w-full max-w-md md:max-w-lg ml-auto md:ml-0 md:mr-auto">
              <div className="relative bg-white/5 border border-white/10 rounded-2xl overflow-hidden shadow-xl p-4">
                <div className="space-y-3">
                  <div className="bg-white/5 rounded-lg p-3 border border-white/10">
                    <p className="text-xs font-semibold text-white">Traitement du dossier</p>
                    <p className="text-[11px] text-slate-200/80 mt-1">
                      Vérification des informations et assistance en cas de doute.
                    </p>
                  </div>
                  <div className="bg-white/5 rounded-lg p-3 border border-white/10">
                    <p className="text-xs font-semibold text-white">Transmission</p>
                    <p className="text-[11px] text-slate-200/80 mt-1">
                      Envoi des éléments nécessaires à la soumission via les plateformes officielles concernées.
                    </p>
                  </div>

                  <p className="text-[10px] text-slate-200/80 text-right">
                    Service d&apos;assistance — non affilié aux gouvernements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Steps section */}
      <section
        id="services"
        className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12 text-center"
      >
        <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900">
          Procédure de demande
        </h2>
        <p className="mt-3 text-sm md:text-base text-slate-600 max-w-2xl mx-auto">
          Vous remplissez un formulaire simplifié. Nous vérifions les informations et vous accompagnons
          jusqu&apos;à la réception de l&apos;autorisation.
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 text-left">
          <article className="bg-white rounded-xl shadow-md p-6 md:p-8 flex flex-col border border-slate-200">
            <div className="flex items-start gap-4">
            <div className="w-8 h-8 shrink-0 rounded-full bg-white text-slate-900 flex items-center justify-center font-semibold text-xs leading-none border border-slate-300">
  1
</div>

              <div>
                <h3 className="font-semibold text-slate-900">
                  Saisie des informations
                </h3>
                <p className="mt-3 text-sm text-slate-600">
                  Vous indiquez vos informations d&apos;identité, de passeport et de voyage sur un formulaire guidé.
                  Les questions sont expliquées en français pour limiter les erreurs.
                </p>
              </div>
            </div>
          </article>

          <article className="bg-white rounded-xl shadow-md p-6 md:p-8 flex flex-col border border-slate-200">
            <div className="flex items-start gap-4">
            <div className="w-8 h-8 shrink-0 rounded-full bg-white text-slate-900 flex items-center justify-center font-semibold text-xs leading-none border border-slate-300">
  2
</div>

              <div>
                <h3 className="font-semibold text-slate-900">
                  Vérification et suivi
                </h3>
                <p className="mt-3 text-sm text-slate-600">
                  Nous vérifions le dossier et vous tenons informé. La décision finale appartient toujours aux autorités.
                </p>
              </div>
            </div>
          </article>
        </div>
      </section>

      {/* BENEFITS / WHY US */}
      <section
        id="benefices"
        className="bg-white border-y border-slate-200 py-8 md:py-12"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h3 className="text-center text-xl md:text-2xl font-extrabold text-slate-900 mb-6">
            Services
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 text-sm">
            <BenefitCard
              title="Réduction des erreurs"
              text="Les formulaires officiels sont en anglais et parfois complexes. Nous clarifions les questions et contrôlons la cohérence des réponses."
            />
            <BenefitCard
              title="Gain de temps"
              text="Vous évitez la recherche d'informations dispersées. Nous centralisons les étapes et les instructions."
            />
            <BenefitCard
              title="Assistance"
              text="Support par e-mail pendant le traitement, en cas de doute ou de complément requis."
            />
          </div>
        </div>
      </section>

      {/* Info section */}
      <section id="suivi" className="bg-slate-50 py-8 md:py-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h3 className="text-center text-xl md:text-2xl font-extrabold text-slate-900 mb-6 md:mb-8">
            Informations importantes
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-5 md:gap-6">
            <Card
              title="Délai indicatif"
              subtitle="De quelques minutes à 2 jours ouvrables en moyenne (selon destination)."
            />
            <Card
              title="Support"
              subtitle="Réponse par e-mail pendant le traitement."
            />
            <Card
              title="Paiement"
              subtitle="Encaissement via Stripe."
            />
            <Card
              title="Données"
              subtitle="Informations chiffrées et utilisées uniquement pour la demande."
            />
          </div>

          <p className="mt-5 md:mt-6 text-[11px] md:text-xs text-center text-slate-500 max-w-2xl mx-auto">
            *Les délais peuvent varier selon la destination, le volume de demandes et la réactivité des autorités.
            Nous ne pouvons pas garantir l&apos;acceptation.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-12">
        <h3 className="text-center text-xl md:text-2xl font-extrabold text-slate-900 mb-6">
          Questions fréquentes
        </h3>

        <div className="space-y-4 text-[12px] md:text-sm text-slate-800">
          <FaqItem
            q="Êtes-vous un site officiel du gouvernement ?"
            a="Non. VisagovAssist est un service d'assistance. Nous vous aidons à remplir et préparer votre demande, puis à la soumettre via les plateformes officielles compétentes."
          />
          <FaqItem
            q="Quand dois-je payer ?"
            a="Le paiement intervient à la fin du formulaire, juste avant le traitement du dossier. Sans paiement validé, la demande n'est pas prise en charge."
          />
          <FaqItem
            q="Que se passe-t-il si ma demande est refusée ?"
            a="La décision finale appartient aux autorités. Nous limitons les erreurs de saisie, mais nous ne pouvons pas garantir l'acceptation."
          />
          <FaqItem
            q="Puis-je refaire une demande plus tard ?"
            a="Oui, selon la destination et le motif du refus, une nouvelle demande peut parfois être déposée."
          />
        </div>
      </section>

      {/* CTA fin */}
      <section className="bg-white border-t border-slate-200 py-6 md:py-8">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center space-y-3">
          <h3 className="text-lg md:text-xl font-extrabold text-slate-900">
            Démarrer la demande
          </h3>
          <p className="text-xs md:text-sm text-slate-700 max-w-xl mx-auto">
            Commencez maintenant. Le formulaire est guidé et ne prend que quelques minutes.
          </p>
          <button
            type="button"
            onClick={() => {
              if (typeof window !== "undefined") {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
            }}
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-md bg-slate-900 text-white text-sm md:text-base font-semibold hover:bg-slate-800 transition"
          >
            Accéder au formulaire
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-white border-t border-slate-200 py-6">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-center md:text-left text-xs md:text-sm text-slate-600">
            © {year} VisagovAssist — Assistance à la demande d&apos;autorisation de voyage (ESTA, eTA, ETA).
            Tous droits réservés.
          </p>
        </div>
      </footer>
    </main>
  );
}
// ---------- Small components ----------
function Card({ title, subtitle, dataTestId }) {
  return (
    <div className="bg-white rounded-xl shadow p-5 flex flex-col gap-2 border border-slate-200" data-testid={dataTestId}>
      <h4 className="font-semibold text-slate-900 text-sm">{title}</h4>
      <p className="text-xs text-slate-600">{subtitle}</p>
    </div>
  );
}

function BenefitCard({ title, text }) {
  return (
    <div className="bg-slate-50 rounded-xl border border-slate-200 p-5 flex flex-col gap-2">
      <h4 className="font-semibold text-slate-900 text-sm">{title}</h4>
      <p className="text-xs text-slate-600">{text}</p>
    </div>
  );
}

function FaqItem({ q, a }) {
  return (
    <details className="bg-white rounded-lg border border-slate-200 px-4 py-3">
      <summary className="cursor-pointer text-sm font-semibold text-slate-900">
        {q}
      </summary>
      <p className="mt-2 text-[12px] text-slate-600">{a}</p>
    </details>
  );
}

// ---------- Page success (après Stripe) ----------
function Success() {
  const [result, setResult] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const run = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const sessionId = params.get("session_id");

        if (!sessionId) {
          setError("Session de paiement introuvable.");
          setLoading(false);
          return;
        }

        const res = await fetch("/.netlify/functions/confirm-payment", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          cache: "no-store",
          body: JSON.stringify({ sessionId }),
        });

        const out = await res.json();

        if (!res.ok) {
          setError(out?.error || "Le paiement n’a pas pu être confirmé.");
          setLoading(false);
          return;
        }

        setResult(out);
        setLoading(false);
      } catch (e) {
        setError("Erreur lors de la validation du paiement.");
        setLoading(false);
      }
    };

    run();
  }, []);

  if (loading) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-slate-50">
        <p className="text-sm text-slate-700">Validation du paiement en cours…</p>
      </main>
    );
  }

  if (error) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="bg-white rounded-xl shadow-md p-6 max-w-md w-full border border-slate-200">
          <h1 className="text-lg font-bold text-red-600 mb-2">
            Paiement non confirmé
          </h1>
          <p className="text-sm text-slate-700 mb-4">{error}</p>
          <button
            onClick={() => (window.location.href = "/")}
            className="w-full px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800"
          >
            Retour à l’accueil
          </button>
        </div>
      </main>
    );
  }

  const demande = result?.demande || null;
  const data = demande?.data || {};

  const destination = data?.destination || "";
  const prenoms = data?.prenoms || "";
  const nom = data?.nom || "";
  const email = data?.email || "";

  const destinationLabel =
    destination === "usa"
      ? "États-Unis (ESTA)"
      : destination === "canada"
      ? "Canada (eTA)"
      : destination === "australie"
      ? "Australie (ETA)"
      : "Destination sélectionnée";

  const numeroCommande =
    result?.numeroCommande ||
    demande?.numero_commande ||
    data?.numeroCommande ||
    "—";

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-50">
      <section className="bg-white rounded-xl shadow-lg p-6 max-w-lg w-full border border-slate-200">
        <div className="mb-4">
          <h1 className="text-lg font-extrabold text-slate-900">
            Paiement confirmé
          </h1>
          <p className="text-xs text-slate-600">
            Votre demande a été enregistrée.
          </p>
        </div>

        <div className="border border-slate-200 bg-slate-50 rounded-lg p-4 mb-4">
          <p className="text-xs text-slate-700 mb-1">Numéro de dossier</p>
          <p className="text-lg font-mono font-bold text-slate-900">
            {numeroCommande}
          </p>
        </div>

        <div className="space-y-2 text-xs text-slate-700 mb-5">
          <p>
            Voyageur :{" "}
            <span className="font-semibold">
              {prenoms || "—"} {nom || ""}
            </span>
          </p>
          <p>
            Destination :{" "}
            <span className="font-semibold">{destinationLabel}</span>
          </p>
          <p>
            Email : <span className="font-semibold">{email || "—"}</span>
          </p>
          <p>
            Statut du dossier :{" "}
            <span className="font-semibold text-emerald-700">Payé</span>
          </p>
        </div>

        <p className="text-[11px] text-slate-500 mb-4">
          Un email de confirmation vous sera envoyé avec le récapitulatif de votre demande.
        </p>

        <div className="flex gap-3">
          <button
            onClick={() => (window.location.href = "/")}
            className="flex-1 px-4 py-2 rounded-md border border-slate-300 text-xs font-semibold hover:bg-slate-50"
          >
            Retour au site
          </button>
        </div>
      </section>
    </main>
  );
}

// ---------- Page cancel (paiement annulé) ----------
function Cancel() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      <section className="max-w-xl mx-auto px-4 md:px-6 py-10">
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 border border-slate-200">
          <div className="mb-4">
            <h1 className="text-lg md:text-xl font-extrabold text-slate-900">
              Paiement annulé
            </h1>
            <p className="text-xs md:text-sm text-slate-600">
              Votre demande n’a pas été finalisée.
            </p>
          </div>

          <p className="text-[11px] md:text-xs text-slate-700 mb-4">
            Vous avez interrompu le paiement sur la page sécurisée Stripe.
            Votre dossier n’est pas pris en compte tant que le règlement n’est
            pas validé.
          </p>

          <button
            onClick={() => (window.location.href = "/")}
            className="w-full text-xs md:text-sm px-4 py-2.5 rounded-md bg-slate-900 text-white font-semibold hover:bg-slate-800 transition"
          >
            Revenir au formulaire
          </button>
        </div>
      </section>
    </main>
  );
}

// ---------- Hook SEO (metas + FAQ JSON-LD) ----------
function useSEO(config) {
  useEffect(() => {
    if (typeof document === "undefined") return;

    const {
      title,
      description,
      robots = "index,follow",
      keywords,
      ogTitle,
      ogDescription,
      jsonLdFaq,
    } = config || {};

    const upsertMeta = (attr, name, content) => {
      if (!content) return;
      let meta = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    if (title) document.title = title;

    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", robots);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("property", "og:title", ogTitle || title);
    upsertMeta("property", "og:description", ogDescription || description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "VisagovAssist");
    upsertMeta("property", "og:locale", "fr_FR");

    if (jsonLdFaq) {
      let script = document.head.querySelector('script[data-visagovassist-faq="true"]');
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-visagovassist-faq", "true");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLdFaq);
    }
  }, [JSON.stringify(config)]);
}

// ---------- APP (Home / Formulaire / Admin / Success / Cancel) ----------
function App() {
  const [view, setView] = useState("home"); // "home" | "form" | "admin"
  const [leadData, setLeadData] = useState(null);

  let routeView = "home"; // "home" | "success" | "cancel" | "admin"
  let path = "/";

  if (typeof window !== "undefined") {
    path = window.location.pathname;

    if (path === "/success") {
      routeView = "success";
    } else if (path === "/cancel") {
      routeView = "cancel";
    } else if (path === "/panel-7xA92-admin") {
      routeView = "admin";
    }
  }

  const faqJsonLd =
    routeView === "home"
      ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "Êtes-vous un site officiel du gouvernement ?",
              acceptedAnswer: {
                "@type": "Answer",
                text:
                  "Non. VisagovAssist est un service d'assistance. Nous vous aidons à remplir et préparer votre demande, puis à la soumettre via les plateformes officielles compétentes pour l'ESTA, l'eTA et l'ETA.",
              },
            },
            {
              "@type": "Question",
              name: "Quand dois-je payer ?",
              acceptedAnswer: {
                "@type": "Answer",
                text:
                  "Le paiement intervient à la fin du formulaire, juste avant le traitement du dossier. Sans paiement validé, la demande n'est pas prise en charge.",
              },
            },
            {
              "@type": "Question",
              name: "Que se passe-t-il si ma demande est refusée ?",
              acceptedAnswer: {
                "@type": "Answer",
                text:
                  "La décision finale appartient aux autorités. Nous limitons les erreurs de saisie, mais nous ne pouvons pas garantir l'acceptation.",
              },
            },
            {
              "@type": "Question",
              name: "Puis-je refaire une demande plus tard ?",
              acceptedAnswer: {
                "@type": "Answer",
                text:
                  "Oui, selon la destination et le motif du refus, une nouvelle demande peut parfois être déposée.",
              },
            },
          ],
        }
      : null;

  let seoConfig;
  if (routeView === "success") {
    seoConfig = {
      title: "Paiement confirmé — Demande ESTA, eTA, ETA | VisagovAssist",
      description:
        "Votre paiement a été confirmé. Votre demande d'ESTA, eTA ou ETA est en cours de traitement par l'équipe VisagovAssist.",
      robots: "noindex,follow",
    };
  } else if (routeView === "cancel") {
    seoConfig = {
      title: "Paiement annulé — Demande ESTA, eTA, ETA | VisagovAssist",
      description:
        "Votre paiement a été annulé. Reprenez facilement votre demande d'ESTA, eTA ou ETA en ligne avec VisagovAssist.",
      robots: "noindex,follow",
    };
  } else {
    seoConfig = {
      title: "Demande ESTA USA, eTA Canada, ETA Australie en ligne | VisagovAssist",
      description:
        "Remplissez en ligne votre demande d'ESTA États-Unis, eTA Canada ou ETA Australie avec VisagovAssist. Formulaire simplifié en français, vérification du dossier et paiement sécurisé Stripe.",
      robots: "index,follow",
      keywords:
        "ESTA, eTA Canada, ETA Australie, e-visa, autorisation de voyage, formulaire ESTA français, visa en ligne, voyage USA, voyage Canada, voyage Australie",
      ogTitle: "Demande ESTA, eTA Canada, ETA Australie en ligne | VisagovAssist",
      ogDescription:
        "Demande en ligne : formulaire en français, vérification du dossier et assistance.",
      jsonLdFaq: faqJsonLd,
    };
  }

  useSEO(seoConfig);

  let content;

  if (routeView === "success") {
    content = <Success />;
  
  } else if (routeView === "cancel") {
    content = <Cancel />;
  
  } else if (routeView === "admin") {
    content = <Admin onBack={() => (window.location.href = "/")} />;
  
  } else if (view === "summary" && leadData) {
    content = (
      <SummaryStep
        leadData={leadData}
        onBack={() => setView("home")}
        onContinue={() => setView("form")}
      />
    );
  
  } else if (view === "form" && leadData) {
    content = (
      <FormulaireVisa
        onBack={() => setView("summary")}
        leadData={leadData}
      />
    );
  
  } else {
    content = (
      <Home
        onStart={(dataFromHome) => {
          setLeadData(dataFromHome);
          setView("summary");
        }}
        onOpenAdmin={() => alert("Accès non autorisé")}
      />
    );
  }  
  
  return <>{content}</>;
  
}

export default App;
